var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4502 9C1.4502 5.82436 4.02456 3.25 7.2002 3.25H17.2002C20.3758 3.25 22.9502 5.82436 22.9502 9V15C22.9502 18.1756 20.3758 20.75 17.2002 20.75H7.2002C4.02456 20.75 1.4502 18.1756 1.4502 15V9ZM6.65024 8.39998C6.31887 8.15145 5.84877 8.21861 5.60024 8.54998C5.35171 8.88135 5.41887 9.35145 5.75024 9.59998L10.5502 13.2C11.528 13.9333 12.8725 13.9333 13.8502 13.2L18.6502 9.59998C18.9816 9.35145 19.0488 8.88135 18.8002 8.54998C18.5517 8.21861 18.0816 8.15145 17.7502 8.39998L12.9502 12C12.5058 12.3333 11.8947 12.3333 11.4502 12L6.65024 8.39998Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.57cfffe37d83e6389ad9427a624fcdb2.svg";
export { ForwardRef as ReactComponent };